import React, { useCallback, useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import { Button } from "@deere/fuel-react";
import {
  GridRowModes,
  GridActionsCellItem,
  // GridEditSingleSelectCell,
} from "@mui/x-data-grid";
import { useTranslation } from "../../common/translation-context";
import { useGridApiContext } from "@mui/x-data-grid-pro";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import ModalMUI from "../../common/data-grid/modal-mui";
import useHttp from "../../common/Hooks/use-Http";
import {
  IB_CCM_Domain_Data,
  IB_CCM_LOCK,
  IB_CCM_UNLOCK,
  IB_DEALER_EDIT,
  IB_DEALER_LIST,
  IB_EDIT_CUST_RATES,
  ROLES,
} from "../../constants/constant";
import SearchBar from "../../common/SearchBar";
import ToastMessageFunction from "../../common/toast-message-function";
import IbDataGrid from "./IbDataGrid";
import ReportSharpIcon from "@mui/icons-material/ReportSharp";
import { getUserRole } from "../../utils/utils";
import { Tooltip } from "@deere/fuel-react";
import InfoIcon from "@mui/icons-material/Info";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useSelector } from "react-redux";

const RatesAllocation = () => {
  const { translate: t } = useTranslation();
  const userData = useSelector((state) => state.userState.userData);
  const toastManager = ToastMessageFunction();
  const [openModal, setOpenModal] = useState(false);
  const [openCustomRateModal, setOpenCustomRateModal] = useState(false);
  const [dealerList, setDealerList] = useState([]);
  const [rateTypeIdAndRateTypeMap, setRateTypeIdAndRateTypeMap] = useState({});
  const [rateTypeList, setRateTypeList] = useState([]);
  const [rateTypeAndRateTypeIdMap, setRateTypeAndRateTypeIdMap] = useState({});
  const [dealerRateTypeAndRatesMapping, setDealerRateTypeAndRatesMapping] =
    useState([]);
  const [dealerRCEditedData, setDealerRCEditedData] = useState();
  const [customRatesEditedData, setCustomRatesEditedData] = useState();
  const [selectedRateTypeId, setSelectedRateTypeId] = useState(null);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const [selectedEntity, setSelectedEntity] = useState();
  const [selectedDealerName, setSelectedDealerName] = useState();
  const [monthData, setMonthData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState();
  const [selectedMonth, setSelectedMonth] = useState();
  const [countryCodeMap, setCountryCodeMap] = useState({});
  const [startEndDataAndFisMonthMap, setStartEndDataAndFisMonthMap] = useState(
    {},
  );
  const [rowModesModel, setRowModesModel] = useState({});
  const [bpFreeze, setBpFreeze] = useState(false);
  const [mondayOrTuesday, setMondayOrTuesday] = useState(false);
  const [isCustomRateEnabled, setIsCustomRateEnabled] = useState(false);
  const [hasManuallyChangedFilters, setHasManuallyChangedFilters] =
    useState(false);
  const [isDataReady, setIsDataReady] = useState(false);
  const location = useLocation();

  const {
    isLoading: isDomainDataLoading,
    sendRequest: fetchDomainData,
    error: domainDataError,
  } = useHttp();
  const {
    isLoading: isDealerListLoading,
    sendRequest: fetchDealerList,
    error: dealerListError,
  } = useHttp();
  const {
    isLoading: isDealerSaveLoading,
    sendRequest: putDealerEditedData,
    error: dealerEditedDataError,
  } = useHttp();
  const {
    isLoading: isCustomRateSaveLoading,
    sendRequest: putCustomRateTypeList,
    error: customRateTypeSaveError,
  } = useHttp();
  const {
    isLoading: isLockRateLoading,
    sendRequest: putLockRates,
    error: lockRatesError,
  } = useHttp();
  const {
    isLoading: isUnLockRateLoading,
    sendRequest: putUnLockRates,
    error: UnLockRatesError,
  } = useHttp();

  // Handling Errors
  const showToast = useCallback(
    (message, severity) => {
      toastManager.getToast(message, severity);
    },
    [toastManager],
  );

  // Handling DataGrid Datas
  // const getCustomRowId = (row) => row.dealerid;

  const getCustomRowId = (row) => {
    if (row.countryCode === "JD") {
      return row.dealerReasonCodeTransactionId;
    } else {
      return row.dealerid;
    }
  };

  const getRate = (data) => {
    return dealerRateTypeAndRatesMapping[data];
  };

  const processRowUpdate = (newData) => {
    
   let updatedData;
  const currentCountryCode = countryCodeMap[selectedCountry];

  if (currentCountryCode === "JD") {
    updatedData = {
      ...newData,
      rateTypeId: newData.rateTypeId,
      rate: newData.rate,
      rateType: newData.rateType,
      referenceTable: newData.rateType.includes("Custom")
        ? "customratetype_master"
        : "ratetype",
    };
  } else {
    updatedData = {
      ...newData,
      rateTypeId: rateTypeAndRateTypeIdMap[newData.rateType],
      rate: dealerRateTypeAndRatesMapping[newData.rateType],
      rateType:
        rateTypeIdAndRateTypeMap[rateTypeAndRateTypeIdMap[newData.rateType]],
      referenceTable: newData.rateType.includes("Custom")
        ? "customratetype_master"
        : "ratetype",
    };
  }
    setDealerEditedData([updatedData]);
    return updatedData;
  };

  const CustomEditComponent = (props) => {
    const apiRef = useGridApiContext();
    const { value, row } = props;
    let valueOptions = [];

    if (row && row.countryCode === "JD" && row.currency) {
      // Filter options for JD and currency, but display only the rate type part (before the last '-')
      valueOptions = rateTypeList
        .filter(
          (option) =>
            option.endsWith(`- ${row.currency}`) ||
            option.endsWith(`-${row.currency}`),
        )  
         .map((option) => {
          // Remove the trailing '- CURRENCY' or '-CURRENCY'
          const idx = option.lastIndexOf("-");
          return idx !== -1 ? option.substring(0, idx).trim() : option;
        });
    } else {
      // For non-JD, show only the rate type part (before the last '-') as well
      valueOptions = rateTypeList;
    }

    const handleChange = (event) => {
      let newValue = event.target.value;
      // For JD, reconstruct the full value with currency for saving
      if (row && row.countryCode === "JD" && row.currency) {
        const original = rateTypeList.find(
          (opt) =>
            (opt.startsWith(newValue + "-") ||
              opt.startsWith(newValue + " -")) &&
            (opt.endsWith(`- ${row.currency}`) ||
              opt.endsWith(`-${row.currency}`)),
        );
        if (original) {
          newValue = original;
        }
      }
      // For non-JD, just use the selected value directly
      const rowId =
        row.countryCode === "JD"
          ? row.dealerReasonCodeTransactionId
          : row.dealerid;
      apiRef.current.setEditCellValue({
        id: rowId,
        field: "rateType",
        value: newValue,
      });
      apiRef.current.setEditCellValue({
        id: rowId,
        field: "rate",
        value: dealerRateTypeAndRatesMapping[newValue],
      });
    };

    return (
      <Select
        value={value || ""}
        onChange={handleChange}
        autoFocus
        fullWidth
        MenuProps={{
          PaperProps: {
            style: { maxHeight: 200 },
          },
        }}
        size="small"
      >
        {valueOptions.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    );
  };

  // Handling APIs Data
  const gettingDomainDataList = (domainDataList, msg) => {
    const monthList = [];
    const startEndDataAndFisMonthList = {};

    const countriesValues = domainDataList?.country
      ? Object.values(domainDataList.country).sort((a, b) => a.localeCompare(b))
      : [];

    const reversedCountries = domainDataList?.country
      ? Object.fromEntries(
          Object.entries(domainDataList.country).map(([key, value]) => [
            value,
            key,
          ]),
        )
      : {};

    const initialCountry = domainDataList?.defaultCountry;

    setCountryData(countriesValues);
    setSelectedCountry(initialCountry);
    setCountryCodeMap(reversedCountries);

    domainDataList?.fiscalDateDTOList.forEach((data) => {
      monthList.push(`${data.startDate} - ${data.endDate}`);
      if (
        !startEndDataAndFisMonthList.hasOwnProperty(
          `${data.startDate} - ${data.endDate}`,
        )
      ) {
        startEndDataAndFisMonthList[`${data.startDate} - ${data.endDate}`] =
          data.fisMonthyear;
      }
    });

    const initialMonth = Object.keys(startEndDataAndFisMonthList).find(
      (key) =>
        startEndDataAndFisMonthList[key] ===
        domainDataList.selectedFisMonthYear,
    );

    setMonthData(monthList);
    setSelectedMonth(initialMonth);
    setStartEndDataAndFisMonthMap(startEndDataAndFisMonthList);

    getDealerListData(
      reversedCountries[initialCountry],
      startEndDataAndFisMonthList[initialMonth],
    );

    setTimeout(() => {
      setIsDataReady(true);
    }, 100);
  };

  const gettingDealerList = (dealerListData, msg) => {
    const rateTypeIdAndRateTypeMap = {};
    const rateTypeList = [];
    const rateTypeAndRateTypeIdMap = {};
    const rateTypeAndRateMap = {};

    setDealerList(dealerListData.dealerReasonCodeTransactionDtoList);
    setButtonDisabled(dealerListData.freezed);
    setBpFreeze(dealerListData.bpFreeze);
    setMondayOrTuesday(dealerListData.mondayOrTuesday === true || dealerListData.mondayOrTuesday === "true");
    setIsCustomRateEnabled(dealerListData.customRates);

    dealerListData?.rateTypeDTOList.forEach((data) => {
      const {
        rateTypeId: id,
        rateTypes: rateTypeKey,
        rate: rateValue,
        currency,
        active: isActive,
      } = data;

      if (isActive) {
        rateTypeIdAndRateTypeMap[id] = rateTypeKey;
          if (!rateTypeList.includes(`${rateTypeKey}-${currency}`)) {
            rateTypeList.push(`${rateTypeKey}-${currency}`);
          }
        rateTypeAndRateMap[`${rateTypeKey}-${currency}`] = rateValue;
        rateTypeAndRateTypeIdMap[`${rateTypeKey}-${currency}`] = id;
      }
    });

    setRateTypeIdAndRateTypeMap(rateTypeIdAndRateTypeMap);
    setRateTypeList(rateTypeList.sort());
    setDealerRateTypeAndRatesMapping(rateTypeAndRateMap);
    setRateTypeAndRateTypeIdMap(rateTypeAndRateTypeIdMap);
  };

  const getDealerSavedResponse = (dealerSaveResponse, msg) => {
    showToast(msg, "success");
    if (msg) getDealerListData();
  };

  const gettingCustomRateSavedResponse = (customRateSaveResponse, msg) => {
    showToast(msg, "success");
    if (msg) getDealerListData();
  };

  const lockRatesData = (data, msg) => {
    showToast(msg, "success");
    if (msg) getDealerListData();
  };

  // Handling APIs Calls
  const getDomainDataList = () => {
    fetchDomainData(
      {
        method: "get",
        url: IB_CCM_Domain_Data,
        customErrorMsg: "Failed to Fetch Domain Data",
      },
      gettingDomainDataList,
    );
  };

  const getDealerListData = (initialCountry, initialMonth) => {
    fetchDealerList(
      {
        method: "get",
        url: IB_DEALER_LIST,
        params: {
          country: selectedCountry
            ? countryCodeMap[selectedCountry]
            : initialCountry,
          fisMonthYear: selectedMonth
            ? startEndDataAndFisMonthMap[selectedMonth]
            : initialMonth,
        },
        customErrorMsg: "Failed to Fetch Dealer List",
      },
      gettingDealerList,
    );
  };

  const setDealerEditedData = (data) => {
    putDealerEditedData(
      {
        method: "PUT",
        url: IB_DEALER_EDIT,
        data,
        customErrorMsg: "Failed to Save",
      },
      getDealerSavedResponse,
    );
  };

  const setCustomRateType = (data) => {
    putCustomRateTypeList(
      {
        method: "put",
        url: IB_EDIT_CUST_RATES,
        data,
        params: {
          countryCode: countryCodeMap[selectedCountry],
          fisMonthYear: startEndDataAndFisMonthMap[selectedMonth],
        },
        customErrorMsg: "Failed to Save Custom Rates",
      },
      gettingCustomRateSavedResponse,
    );
  };
const handleLockUnlockClick = () => {
  const missingRow = dealerList.find(
    (row) =>
      row.rate == null ||
      row.rateType == null ||
      row.rateTypeId == null ||
      row.rate === "" ||
      row.rateType === "" ||
      row.rateTypeId === ""
  );
  if (missingRow) {
    showToast(
      `Missing Rate, Rate Type, or Rate Type ID for dealer: ${missingRow.dealerName || missingRow.dealerid}`,
      "error"
    );
    return;
  }
  if (!buttonDisabled) {
    handleLockRates();
  } else {
    handleUnLockRates();
  }
};
  const lockRates = (data) => {
    putLockRates(
      {
        method: "PUT",
        url: IB_CCM_LOCK,
          params: {
          countryCode: countryCodeMap[selectedCountry],
          fisMonthYear: startEndDataAndFisMonthMap[selectedMonth],
        },
       // data,
        customErrorMsg: "Failed to Lock",
      },
      lockRatesData,
    );
  };

  const unLockRates = (data) => {
    putUnLockRates(
      {
        method: "PUT",
        url: IB_CCM_UNLOCK,
       params: {
          countryCode: countryCodeMap[selectedCountry],
          fisMonthYear: startEndDataAndFisMonthMap[selectedMonth],
        },
       // data,
        customErrorMsg: "Failed to UnLock",
      },
      lockRatesData,
    );
  };

  // Handling DataGrid Clicks
  const handleEditClick = (id) => () => {
    setRowModesModel((prev) => ({
      ...prev,
      [id]: { mode: GridRowModes.Edit },
    }));
  };

  const handleSaveClick = (id) => () => {
    setRowModesModel((prev) => ({
      ...prev,
      [id]: { mode: GridRowModes.View },
    }));
  };

  const handleCancelClick = (id) => () => {
    setRowModesModel((prev) => ({
      ...prev,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    }));
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  // Handling Modal
  const handleDealerRCEditedData = setDealerRCEditedData;

  const handleCustomRatesEditedData = setCustomRatesEditedData;

  const handleModalOpening = (id) => {
    const currentCountryCode = countryCodeMap[selectedCountry];
    let entity;
    if (currentCountryCode !== "JD") {
      // For non-JD countries, find by dealerid
      entity = dealerList.find((row) => row.dealerid === id);
      setSelectedRow(id);
      setSelectedRateTypeId(entity?.rateTypeId);
    } else {
      // For JD country, find by dealerReasonCodeTransactionId
      entity = dealerList.find(
        (row) => row.dealerReasonCodeTransactionId === id,
      );
      setSelectedRateTypeId(entity?.rateTypeId);
      setSelectedRow(entity?.dealerid);
    }
    //setSelectedRow(id);
    setSelectedDealerName(entity.dealerName);
    setSelectedEntity(entity.entityType);
    setOpenModal(true);
  };
  const handleModalClosing = () => {
    setOpenModal(false);
    setOpenCustomRateModal(false);
  };

  const handleModalSaving = useCallback(() => {
    setDealerEditedData(dealerRCEditedData);
    setOpenModal(false);
  }, [dealerRCEditedData]);

  const handleCustomModalSaving = useCallback(() => {
    setCustomRateType(customRatesEditedData);
    setOpenCustomRateModal(false);
  }, [customRatesEditedData]);

  const handleLockRates = () => lockRates(dealerList);

  const handleUnLockRates = () => unLockRates(dealerList);

  const handleCustomRates = () => setOpenCustomRateModal(true);

  // Update the handler functions to set the manual change flag
  const handleCountryChange = (value) => {
    setSelectedCountry(value);
    setHasManuallyChangedFilters(true);
  };

  const handleMonthChange = (value) => {
    setSelectedMonth(value);
    setHasManuallyChangedFilters(true);
  };

  // Components for Rendering
  const countryAndFisMonthComp = (
    <SearchBar
      countryList={countryData}
      selectedCountry={selectedCountry}
      selectedMonth={selectedMonth}
      monthList={monthData}
      handleIbCountryChange={handleCountryChange}
      handleIbMonthChange={handleMonthChange}
    />
  );

  const reasonCodeModal = (
    <ModalMUI
      rateTypeId={selectedRateTypeId}
      type="ReasonCodes"
      loading={isDealerSaveLoading}
      open={openModal}
      delaerId={selectedRow}
      dealerName={selectedDealerName}
      entity={selectedEntity}
      handleCloseModal={handleModalClosing}
      handleSaveModal={handleModalSaving}
      handleDealerRCEditedData={handleDealerRCEditedData}
      rateTypeIdAndRateTypeMap={rateTypeIdAndRateTypeMap}
      rateTypeList={rateTypeList}
      rateTypeAndRateTypeIdMap={rateTypeAndRateTypeIdMap}
      rateTypeAndRateMap={dealerRateTypeAndRatesMapping}
      dealerRateTypeAndRatesMapping={dealerRateTypeAndRatesMapping}
      startEndDataAndFisMonthMap={startEndDataAndFisMonthMap}
      countryCodeMap={countryCodeMap}
      selectedMonth={selectedMonth}
      selectedCountry={selectedCountry}
      isParentLocked={buttonDisabled}
    />
  );

  const customRateModal = (
    <ModalMUI
      type="CustomRates"
      open={openCustomRateModal}
      handleCloseModal={handleModalClosing}
      handleSaveModal={handleCustomModalSaving}
      handleCustomRatesEditedData={handleCustomRatesEditedData}
      startEndDataAndFisMonthMap={startEndDataAndFisMonthMap}
      countryCodeMap={countryCodeMap}
      selectedMonth={selectedMonth}
      selectedCountry={selectedCountry}
      isParentLocked={buttonDisabled}
      rateTypeId={selectedRateTypeId}
    />
  );

 const lockRatesButtonComp = (
  <div style={{ paddingTop: "2%" }}>
    <strong style={{ fontSize: "21px" }}>{t("ratesAllocation")}</strong>
    <div
      style={{
        marginBottom: "0px",
        marginRight: "1.5%",
        display: "flex",
        gap: "7%",
      }}
      className="button"
    >
      {isCustomRateEnabled && (
        <Button variant="secondary" onClick={handleCustomRates}>
          Custom Rates
        </Button>
      )}
      {getUserRole(userData) === ROLES.CCM &&
        !bpFreeze &&
        !mondayOrTuesday &&
        !isDealerListLoading &&
        (
          <Button
            variant="primary"
            onClick={handleLockUnlockClick}
            style={{ marginRight: "10px" }}
          >
            {buttonDisabled ? "UnLock Rates" : "Lock Rates"}
          </Button>
        )}
    </div>
  </div>
);

  // Handling UseEffects
  useEffect(() => {
    if (dealerListError) showToast(dealerListError, "error");
    if (dealerEditedDataError) showToast(dealerEditedDataError, "error");
    if (domainDataError) showToast(domainDataError, "error");
    if (lockRatesError) showToast(lockRatesError, "error");
    if (UnLockRatesError) showToast(UnLockRatesError, "error");
    if (customRateTypeSaveError) showToast(customRateTypeSaveError, "error");
  }, [
    dealerListError,
    dealerEditedDataError,
    domainDataError,
    lockRatesError,
    UnLockRatesError,
    customRateTypeSaveError,
  ]);

  useEffect(() => {
    const expectedPaths = ["/ratesAllocation"];

    const isRatesAllocationPage = expectedPaths.some((path) =>
      location.pathname.toLowerCase().includes(path.toLowerCase()),
    );

    if (!isRatesAllocationPage) {
      return;
    }

    if (
      !isDataReady ||
      !countryCodeMap ||
      Object.keys(countryCodeMap).length === 0
    ) {
      return;
    }

    if (!hasManuallyChangedFilters) {
      return;
    }

    const userRole = getUserRole(userData);
    const currentCountryCode = countryCodeMap[selectedCountry];
    const countriesRequiringBothFilters = ["DE", "FR", "IT"];

    if (
      userRole === ROLES.CCM &&
      countriesRequiringBothFilters.includes(currentCountryCode)
    ) {
      if (selectedMonth) {
        getDealerListData();
      }
    } else {
      if (selectedCountry && selectedMonth) {
        const timeoutId = setTimeout(() => {
          getDealerListData();
        }, 2000);
        return () => clearTimeout(timeoutId);
      }
    }
  }, [selectedCountry, selectedMonth, isDataReady, userData, countryCodeMap]);

  useEffect(() => {
    getDomainDataList();
  }, []);

  // Handle incoming navigation with country from dashboard
  useEffect(() => {
    if (location.state?.selectedCountry && isDataReady && countryData.length > 0) {
      const countryFullName = Object.keys(countryCodeMap).find(
        key => countryCodeMap[key] === location.state.selectedCountry
      );
      if (countryFullName && countryData.includes(countryFullName)) {
        setSelectedCountry(countryFullName);
        // Clear the state to avoid re-triggering
        window.history.replaceState({}, document.title);
      }
    }
  }, [location.state, isDataReady, countryCodeMap, countryData]);

  const columns = [
    {
      field: "error",
      headerName: "",
      width: 45,
      renderCell: (params) =>
        params.row.error && (
          <Tooltip title="Reason Codes Data Missing">
            <ReportSharpIcon
              style={{ color: "#C21020", marginTop: "45%", paddingTop: "2%" }}
            />
          </Tooltip>
        ),
    },
    {
      field: "differentRateType",
      headerName: "",
      width: 45,
      renderCell: (params) =>
        params.row.differentRateType && (
          <Tooltip title="Reason Codes Rates Are Different">
            <InfoIcon
              style={{ color: "#005DB1", marginTop: "39%", paddingTop: "7%" }}
            />
          </Tooltip>
        ),
    },
    {
      field: "dealerid",
      width: 220,
      editable: false,
      renderHeader: () => <strong>Dealer ID</strong>,
    },
    {
      field: "dealerName",
      width: 310,
      editable: false,
      renderHeader: () => <strong>Dealer Name</strong>,
    },
    {
      field: "currency",
      width: 310,
      editable: false,
      renderHeader: () => <strong>Currency</strong>,
    },
    {
      field: "entityType",
      width: 200,
      editable: false,
      renderHeader: () => <strong>Entity Type</strong>,
    },
    {
      field: "rateType",
      width: 200,
      editable: true,
      type: "singleSelect",
      // valueOptions: rateTypeList,
      renderCell: (params) => {
        if (params.row.rateType === null || params.row.rateType === "")
          return "";
        // For JD country, show only rateType
        const currentCountryCode = countryCodeMap[selectedCountry];
        if (currentCountryCode === "JD") {
          return params.row.rateType;
        }
        return `${params.row.rateType}-${params.row.currency}`;
      },
      renderEditCell: (params) => <CustomEditComponent {...params} />,
      renderHeader: () => <strong>Rate Type</strong>,
    },
    {
      field: "rate",
      width: 200,
      editable: true,
      renderHeader: () => <strong>Rate (%)</strong>,
      valueOptions: ({ row }) => {
        if (row.rateType === null || row.rateType === "") return " ";
        return getRate(`${row.rateType}-${row.currency}`);
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "actions",
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
        const isRoleNotCCM = !(getUserRole(userData) === ROLES.CCM);
        if (isRoleNotCCM || bpFreeze) {
          return [
            <Tooltip title="Reason Codes">
              <GridActionsCellItem
                icon={<AddIcon />}
                label="Open RC"
                sx={{ color: "primary.main" }}
                onClick={() => handleModalOpening(id)}
              />
            </Tooltip>,
          ];
        }
        if (isInEditMode) {
          return [
            <Tooltip title="Save">
              <GridActionsCellItem
                icon={<SaveIcon />}
                label="Save"
                sx={{ color: "primary.main" }}
                onClick={handleSaveClick(id)}
              />
            </Tooltip>,
            <Tooltip title="Cancel">
              <GridActionsCellItem
                icon={<CancelIcon />}
                label="Cancel"
                sx={{ color: "primary.main" }}
                onClick={handleCancelClick(id)}
              />
            </Tooltip>,
          ];
        }

        return [
          <Tooltip title="Edit">
            <GridActionsCellItem
              icon={<EditIcon />}
              label="Edit"
              sx={{ color: "primary.main" }}
              onClick={handleEditClick(id)}
              disabled={buttonDisabled}
            />
          </Tooltip>,
          <Tooltip title="Reason Codes">
            <GridActionsCellItem
              icon={<AddIcon />}
              label="Open RC"
              sx={{ color: "primary.main" }}
              onClick={() => handleModalOpening(id)}
            />
          </Tooltip>,
        ];
      },
    },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", padding: "0.5%" }}>
      {toastManager.toast}
      {selectedCountry && countryAndFisMonthComp}
      {selectedRow && openModal && reasonCodeModal}
      {openCustomRateModal && customRateModal}
      {selectedCountry && lockRatesButtonComp}
      <IbDataGrid
        getRowId={getCustomRowId}
        loading={
          isDomainDataLoading ||
          isDealerListLoading ||
          isDealerSaveLoading ||
          isLockRateLoading ||
          isUnLockRateLoading ||
          isCustomRateSaveLoading
        }
        rows={dealerList}
        columns={columns}
        rowModesModel={rowModesModel}
        onRowModesModelChange={handleRowModesModelChange}
        processRowUpdate={processRowUpdate}
        initialState={{
          sorting: {
            sortModel: [
              { field: "error", sort: "desc" },
              { field: "dealerid", sort: "asc" },
            ],
          },
        }}
      />
    </div>
  );
};

export default RatesAllocation;